$(document).ready(function(){var e=$(window).width();function t(e){let t=$(e).parent().children("input").val();t=t.replace(/\s+/g,"+").toLowerCase();e="/search?view=wholesale&q="+t;window.location.href=e}(0<$(".wholesale-template").length&&769<=e?$("#cart-sidebar"):$("#wholesale-cart-items")).remove(),$("#wholesale-search input").on("keyup",function(e){"Enter"!==e.key&&13!==e.keyCode||t(this)}),$("#wholesale-search .input-icons button").on("click",function(){t(this)}),document.getElementById("RecoverEmail-email-error")&&$(".account-login-container ul.accordion-content").addClass("expanded");let n=document.getElementsByClassName("tier-container"),a=document.querySelectorAll(".darken-bg"),o=($(".customer-level a.pop-up").on("click",function(){$(n).addClass("expanded"),$(a).addClass("expanded")}),$(".tier-container button.close-popup").on("click",function(){$(n).removeClass("expanded"),$(a).removeClass("expanded")}),document.getElementById("form-content")),i=document.getElementsByClassName("user-type-modal");$(".account-register-container .user-type").on("click",function(){$(i).hasClass("active")&&$(i).removeClass("active"),$(o).is(".home, .office, .hospitality")&&$(o).removeClass(),$(this).is("#home")&&($(o).addClass("home"),window.scrollTo(0,0)),$(this).is("#office")&&$(o).addClass("office"),$(this).is("#hospitality")&&$(o).addClass("hospitality")}),$("#back-user-type").on("click",function(){$(i).addClass("active"),$(o).is(".home, .office, .hospitality")&&$(o).removeClass()});var e=document.getElementsByClassName("account-register-container"),s=document.getElementsByClassName("error-banner"),e=(e.length&&s.length&&$(o).addClass("home"),document.querySelectorAll("nav.account-customer")),s=$(e).find(".center-navigation ul.navigation-header");let c=$(location).attr("href");e=c.split("?")[1];let l;l=e?""+location.pathname+location.search:location.pathname,$(s).find("li").each(function(){$(this).children().attr("href")==l&&$(this).attr("selected","")});e=document.querySelectorAll(".accounts-mobile-navigation"),s=$(e).find("ul.navigation-header"),$(s).find("li").each(function(){$(this).find(".link").children().attr("href")==l&&$(this).attr("selected","")}),$(".accounts-mobile-navigation li.heading .action").on("click",function(){$(this).closest(".navigation-header").hasClass("active")?$(this).closest(".navigation-header").removeClass("active"):$(this).closest(".navigation-header").addClass("active")}),e=document.getElementById("AddressCountryNew");e&&$("select#AddressCountryNew > option:first-child").text("Country")});
var app_url = "https://76k7muuc7k.execute-api.us-east-2.amazonaws.com/somage/app/";
var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];

var g_colours = {
  "red_brown": "#791c17",
  "alert_green": "#7CAD30",
  "greenish_grey": "{{ settings.accent_colour }}",
  "black": "#000000"
};

var pricing_formatter = {
  formatPricing: function(number, decPlaces, decSep, thouSep){
    number = number / 100.00; //convert from cents
    decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
    decSep = typeof decSep === "undefined" ? "." : decSep;
    thouSep = typeof thouSep === "undefined" ? "," : thouSep; 
    var sign = number < 0 ? "-$" : "$";
    var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
    var j = (j = i.length) > 3 ? j % 3 : 0;

    return sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
  }
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


/*============================================================================
  Countdown Timer
==============================================================================*/

var countdownTimer = {
  cutoffHour: 15,
  cutoff_seconds: (1100*60*60)/100,
  timer_selector: ".countdown-timer .time",
  init: function(){
    var _this = this;
    var date = new Date();
    if(date.getHours() < _this.cutoffHour && $(".countdown-timer").length > 0){
      _this.incrementTimer();
    }else{
      $('.countdown-timer').css({"opacity": "1"});
    }
  },
  incrementTimer: function(){
    var _this = this;
    setTimeout(function(){
      var date = new Date();
      var seconds = date.getHours() * 60 * 60 + date.getMinutes() * 60 + date.getSeconds();
      var remaining = _this.cutoff_seconds - seconds;
      if(remaining <= 0){
        remaining = (24 * 60 * 60) + remaining;
      }      
      var remaining_seconds = parseInt(remaining % 60);
      var remaining_minutes = parseInt((remaining / 60) % 60);
      var remaining_hours = parseInt((remaining / 60 / 60));
      $(_this.timer_selector).text(remaining_hours+"h "+remaining_minutes+"m "+remaining_seconds+"s");
      $('.countdown-timer').css({"opacity": "1"});
      _this.incrementTimer();
    },1000);    
  }
}


function shadeColor(color, percent) {

    var R = parseInt(color.substring(1,3),16);
    var G = parseInt(color.substring(3,5),16);
    var B = parseInt(color.substring(5,7),16);

    R = parseInt(R * (100 + percent) / 100);
    G = parseInt(G * (100 + percent) / 100);
    B = parseInt(B * (100 + percent) / 100);

    R = (R<255)?R:255;  
    G = (G<255)?G:255;  
    B = (B<255)?B:255;  

    var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
    var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
    var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

    return "#"+RR+GG+BB;
}

function getBase64(file, onLoadCallback) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() { resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

Date.prototype.addHours= function(h){
    this.setHours(this.getHours()+h);
    return this;
}

Date.prototype.formatDate = function(format)
{
    var date = this;
    var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    var days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    if (!format)
      format="MM/dd/yyyy";               
 
    var month = months[date.getMonth()];
    var year = date.getFullYear();
    var day = days[date.getDay()];
  
 
    format = format.replace("MM", month.toString());
  
    format = format.replace("D", day.toString());
 
    if (format.indexOf("yyyy") > -1)
        format = format.replace("yyyy",year.toString());
    else if (format.indexOf("yy") > -1)
        format = format.replace("yy",year.toString().substr(2,2));
 
    format = format.replace("dd",date.getDate().toString());
 
    var hours = date.getHours();       
    if (format.indexOf("t") > -1)
    {
       if (hours > 11)
        format = format.replace("t","pm")
       else
        format = format.replace("t","am")
    }
    if (format.indexOf("HH") > -1)
        format = format.replace("HH",hours.toString());
    if (format.indexOf("hh") > -1) {
        if (hours > 12) hours - 12;
        if (hours == 0) hours = 12;
        format = format.replace("hh",hours.toString());        
    }
    if (format.indexOf("mm") > -1)
       format = format.replace("mm",date.getMinutes().toString());
    if (format.indexOf("ss") > -1)
       format = format.replace("ss",date.getSeconds().toString());
    return format;
}
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' '){
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function showMessage(message, type="confirm"){
  $(".universal-notice .un-inner").text(message);
  $(".universal-notice, .content-blocker").css({"opacity": "1", "pointer-events": "all"});  
}

function hideMessage(){
  $(".universal-notice, .content-blocker").css({"opacity": "0", "pointer-events": "none"});
}


// here i ammmm

var account = {
  create_url: app_url+"users/create",
  create_sub_url: app_url+"users/create-sub",
  get_url: app_url+"users",
  rate_url: app_url+"users/shippingstatus",
  update_url: app_url+"users/update",
  address_url: app_url+"users/addresses",
  delete_url: app_url+"users/delete",
  checkout_url: "https://761tsy2dbi.execute-api.us-east-2.amazonaws.com/store/checkout",
  generate_invoice: app_url+"invoices/invoice",
  app_user: {},
  user: {},
  regions: {},
  invoices: [],
  payments: [],
  invoice_return: "",
  statements: [],
  reorder_items: [],
  submitted_user_info: {},
  updated_user_info: {},
  type_reference: {
    "universal": {
      "name": "Consumer",
      "level": "1",
      "full_name": "Consumer Level <span> 1 </span>"
    }, 
    "consumer2": {
      "name": "Consumer",
      "level": "2",
      "full_name": "Consumer Level 2"
    }, 
    "consumer3": {
      "name": "Consumer",
      "level": "3",
      "full_name": "Consumer Level 3"
    }, 
    "consumerb": {
      "name": "Consumer",
      "level": "4",
      "full_name": "Consumer Business"
    }, 
    "consumerB": {
      "name": "Consumer",
      "level": "4",
      "full_name": "Consumer Business"
    },      
    "foodservice": {
      "name": "Foodservice",
      "level": "1",
      "full_name": "Foodservice Level 1"
    },    
    "foodservice1": {
      "name": "Foodservice",
      "level": "1",
      "full_name": "Foodservice Level 1"
    },
    "foodservice2": {
      "name": "Foodservice",
      "level": "2",
      "full_name": "Foodservice Level 2"
    },
    "foodservice3": {
      "name": "Foodservice",
      "level": "3",
      "full_name": "Foodservice Level 3"
    },
    "distributor1": {
      "name": "Distributor",
      "level": "1",
      "full_name": "Distributor Level 1"
    },
    "distributor2": {
      "name": "Distributor",
      "level": "2",
      "full_name": "Distributor Level 2"
    },
    "distributor3": {
      "name": "Distributor",
      "level": "3",
      "full_name": "Distributor Level 3"
    },"mv22_5":{
      "name": "Multi Venue",
      "level": "3",
      "full_name": "Multi Venue 22.5%"
    },
    "mv12_5":{
      "name": "Multi Venue",
      "level": "2",
      "full_name": "Multi Venue 12.5%"
    },
    "mv":{
      "name": "Multi Venue",
      "level": "1",
      "full_name": "Multi Venue"
    },
    "mv7_5":{
      "name": "Multi Venue",
      "level": "1",
      "full_name": "Multi Venue 7.5%"
    },
    "mv17_5":{
      "name": "Multi Venue",
      "level": "2",
      "full_name": "Multi Venue 17.5%"
    }         
  },  
  current_invoice: {
    id: "",
    encoded: ""
  },
  balances: {},
  init: function(){
    var _this = this;
    _this.getUser(function(){
      _this.buildUserObject();
      _this.setListeners();
      
      _this.setOverviewStats();
      _this.setGeneralInfo();
      _this.setFinancials();
      _this.buildOrdersSection();
      _this.setUsersSection();
      
      _this.makeMenuAvailable();

      // _this.buildAddresses();
      // _this.populateEditAddress('7540590346322');

      setTimeout(function(){
        _this.populateUsersSelect(".address-owner-rr");
        _this.buildAddresses();

      },1000);

     // setTimeout(function(){
     //    _this.populateUsersSelect(".address-owner-rr");
     //    _this.buildAddresses();
     //  },3000);
      
      countdownTimer.init();
      
    });    
  },
  getUser: function(cb){
    var _this = this;
    var params = {"user_id": g_customer.id};
    var su = getCookie("su");
    
    if(su !== ""){
      params.sub_user = su;
    }
                  
    $.get(_this.get_url, params).done(function(data){
      if(data.statusCode === 500){
        console.log(data.body);
      }
      console.log(data);
      _this.app_user = data.body;

      try {
        var userObj = data.body;
        
        if(('user_type' in userObj) && ('first_name' in userObj) && (userObj['user_type'] == "sub")){
         
          $(".customerhname").text('Hello '+userObj['first_name']);
          $(".customerhiname").text('Hi '+userObj['first_name']);
          $(".smalldf p").text('Welcome '+userObj['first_name']);          
        }
        
      } catch(err) {}

        
      
      localStorage.setItem("user", JSON.stringify(_this.app_user));
      cb();
    });     
  },
  buildUserObject: function(){
    var _this = this;
    var user = {};
    
    //define user with logged base account values
    if(typeof g_customer !== "undefined"){
      user.user_id = g_customer.id;
      user.tags = g_customer.tags;
      user.type = g_customer.type;
    }else{
      console.log("no global customer defined");
    }
    
    var keys = ["email", "first_name", "user_id", "last_name", "orders", "phone", "tags", "user_type", "credit_limit", "credit_used"];
    var map_keys = ["default_address", "business_info", "sub_users_full"];
    var array_keys = ["addresses", "sub_users", "locations", "access_authorities"];
    
    //add app values
    if(Object.keys(_this.app_user).length !== 0){
      for(var k in keys){
        var key = keys[k];
        if(_this.app_user.hasOwnProperty(key)){
          user[key] = _this.app_user[key];
        }else{
          user[key] = "";
        }
      }
      
      for(var mk in map_keys){
        var mk_key = map_keys[mk];
        if(_this.app_user.hasOwnProperty(mk_key)){
          user[mk_key] = _this.app_user[mk_key];
        }else{
          user[mk_key] = {};
        }
      }
      
      for(var ak in array_keys){
        var ak_key = array_keys[ak];
        if(_this.app_user.hasOwnProperty(ak_key)){
          user[ak_key] = _this.app_user[ak_key];
        }else{
          user[ak_key] = [];
        }
      }     
      
      _this.app_user.permissions = ["default"];      
    }else{
      console.log("app user has not been set");
    }
    
    _this.user = user;
    _this.app_user = user;
  },
  buildUserFromForm: function(){
    var _this = this;
    
    var address_elements = [
      {"selector":"#address_street", "key": "address1"},
      {"selector":"#address_suburb", "key": "city"},
      {"selector":"#address_postcode", "key": "zip"},
      {"selector":"#address_country", "key": "country"},
      {"selector":"#address_state", "key": "province"}      
    ];
    
    var business_info_elements = [
      {"selector":"#business_name", "key": "business_name"},
      {"selector":"#abn", "key": "abn"},
      {"selector":"#business_type", "key": "business_type"},
      {"selector":"#coffee_supplier", "key": "coffee_supplier"},
      {"selector":"#instagram", "key": "ig_handle"},
      {"selector":"#notes", "key": "notes"}
    ];
    
    var core_elements = [
      {"selector":"#phone_number", "key": "phone"}
    ];
    
    if($("#business_type").find("option:selected").val() === "Other"){
      if($("#business_type_other").val() === ""){
        $(".general-update").text("Update").attr("disabled", false);
        showMessage('Please fill out the "Business Type (Other)" field');
        return;
      }
    } 
    
    if($("#address_state").find("option:selected").val() === ""){
        $(".general-update").text("Update").attr("disabled", false);
        showMessage('Please select an option from the "State" field');
        return;
    }  
    
    for(var ae in address_elements){
      var selector = address_elements[ae].selector;
      var map_key = address_elements[ae].key;
      _this.user.default_address[map_key] = $(selector).val();
    }
    
    for(var bie in business_info_elements){
      var selector = business_info_elements[bie].selector;
      var map_key = business_info_elements[bie].key;
      _this.user.business_info[map_key] = $(selector).val();
    }
    
    for(var ce in core_elements){
      var selector = core_elements[ce].selector;
      var map_key = core_elements[ce].key;
      _this.user[map_key] = $(selector).val();
    }    
    
    delete _this.user.default_address.address2;        
    
    _this.updateUser(function(){
      $(".general-update").css({"background": "#000"}).text("Update").attr("disabled", false);
      showMessage("User Updated");
      $(".edit-general-inner").hide();
      $(".account-general-inner").show();
      _this.setGeneralInfo();      
    });
    
    return;
  },
  makeMenuAvailable: function(){
    var _this = this;
    
    var permissions = {
      "users": ["users"],
      "locations": ["locations"],
      "location_edit": ["locations"],
      "financials": ["financials"]
    }      
    
    //account owner
    if(_this.app_user.hasOwnProperty("user_type") && _this.app_user.user_type !== "sub"){
      $("#general-edit").css({"opacity": "1", "pointer-events": "all"});
      for(var up in permissions){
        for(var lp in permissions[up]){
          $(".user-page-menu-item[data-link='"+permissions[up][lp]+"']").css({"pointer-events": "all"}).text(permissions[up][lp]);
          $("#user-page-menu-mobile option[value='"+permissions[up][lp]+"']").removeClass("hidden");          
        }  
      }
      return;
    }    
    
    //sub account
    if(_this.app_user.hasOwnProperty("access_authorities")){      
            

      var access_auth = _this.app_user.access_authorities;
      
      for(var p in access_auth){
        var up = access_auth[p];
        if(permissions.hasOwnProperty(up)){
          for(var lp in permissions[up]){
            $(".user-page-menu-item[data-link='"+permissions[up][lp]+"']").css({"pointer-events": "all"}).text(permissions[up][lp]);
            $("#user-page-menu-mobile option[value='"+permissions[up][lp]+"']").removeClass("hidden");
          }
        }
      }

      if(!access_auth.includes("locations") && !access_auth.includes("location_edit")){
        $(".account-customer  .heading[data-title='locations']").addClass("notauthorized");
        $(".account-customer  .heading[data-title='locations'] a").attr("href", "/account");
        $(".addeditbtn").remove();
        $(".add-address").remove();
        $(".addaddbtn").remove();

        $(".account-customer  .heading[data-title='addresses']").addClass("notauthorized");
        $(".account-customer  .heading[data-title='addresses'] a").attr("href", "/account");
    
      }
      if(!access_auth.includes("financials")){
        $(".account-customer  .heading[data-title='financials']").addClass("notauthorized");
        $(".account-customer  .heading[data-title='financials'] a").attr("href", "/account");
      }
      if(!access_auth.includes("users")){
        $(".account-customer  .heading[data-title='users']").addClass("notauthorized");
        $(".account-customer  .heading[data-title='users'] a").attr("href", "/account");
      }
      
      if($(".notauthorized[selected='selected']").length){
        location.href = '/account';
        alert("You don't have required access permission to view this page");
      }
      if(location.href.includes('/account?view=users') && !access_auth.includes("users")){
        location.href = '/account';
        alert("You don't have required access permission to view this page");
      }
      
      if(access_auth.includes("location_edit") && !access_auth.includes("locations")){
        // $(".address-tile.new-address").remove();
        $(".add-address").remove();
        $(".addaddbtn").remove();
        
      }
    }
    
    // user_id_rr = _this.app_user.user_id;
    
  },
  editAddress: function(){
    var _this = this;
    var address_elements = [
      {"selector":"#edit_address_first_name", "key": "first_name"},
      {"selector":"#edit_address_last_name", "key": "last_name"},
      {"selector":"#edit_address_company", "key": "company"},
      {"selector":"#edit_address_address1", "key": "address1"},
      {"selector":"#edit_address_address2", "key": "address2"},
      {"selector":"#edit_address_city", "key": "city"},
      {"selector":"#edit_address_country", "key": "country"},
      {"selector":"#edit_address_province", "key": "province"},
      {"selector":"#edit_address_zip", "key": "zip"},
      {"selector":"#edit_address_phone", "key": "phone"},
      {"selector":"#edit_address_owner", "key": "owner"}     
    ];
    
    $(".address-submit").css({"background": g_colours.greenish_grey}).text("Updating...").attr("disabled", "disabled");
    
    var id = $("#edit_address_id").val();
    _this.user.addresses[id] = {};
    
    for(var e in address_elements){
      var selector = address_elements[e].selector;
      var key = address_elements[e].key;
      if($(selector).val() === "" && key !== "address2"){
        $(".address-submit").css({"background": "#000"}).text("Update").attr("disabled", false);
        showMessage("Please fill out all fields");
        return;
      }
      _this.user.addresses[id][key] = $(selector).val();
    }
    
    var address = _this.user.addresses[id];
    address.id = id;
    var user_id = _this.app_user.user_id;
    
    _this.updateAddress(address,user_id,function(){
      $(".address-submit").css({"background": "#000"}).text("Update").attr("disabled", false);
      $(".address-edit-close").click();
    });    
  },
  addAddress: function(){
    var _this = this;
    var address_elements = [
      {"selector":"#new_address_first_name", "key": "first_name"},
      {"selector":"#new_address_last_name", "key": "last_name"},
      {"selector":"#new_address_company", "key": "company"},
      {"selector":"#new_address_address1", "key": "address1"},
      {"selector":"#new_address_address2", "key": "address2"},
      {"selector":"#new_address_city", "key": "city"},
      {"selector":"#new_address_country", "key": "country"},
      {"selector":"#new_address_province", "key": "province"},
      {"selector":"#new_address_zip", "key": "zip"},
      {"selector":"#new_address_phone", "key": "phone"},
      {"selector":"#new_address_owner", "key": "owner"}     
    ];
    
    var id = "new";
    _this.user.addresses[id] = {};
    
    $(".address-submit").css({"background": g_colours.greenish_grey}).text("Adding...").attr("disabled", "disabled");
    
    for(var e in address_elements){
      var selector = address_elements[e].selector;
      var key = address_elements[e].key;
      if($(selector).val() === "" && key !== "address2"){
        $(".address-submit").css({"background": "#000"}).text("Update").attr("disabled", false);
        showMessage("Please fill out all fields");
        return;
      }
      _this.user.addresses[id][key] = $(selector).val();
    }
    
    console.log(_this.user.addresses[id]);
    
    var address = _this.user.addresses[id];
    address.id = "new";
    var user_id = _this.app_user.user_id;
    
    _this.updateAddress(address,user_id,function(){
      $(".address-submit").css({"background": "#000"}).text("Update").attr("disabled", false);
      $(".address-edit-close").click();
    });
  },
  updateAddress: function(address, id, cb){
    var _this = this;
    
    var params = {
      "address": address,
      "user_id": id
    }
    
    params = JSON.stringify(params);
    
    console.log(params);
    
    $.ajax({
      type: "POST",
      url: _this.address_url,
      data: params
    }).done(function(data) {
      console.log(data);
      if(data.body.error){
        showMessage(data.body.error); 
      }
      if(cb){
        cb(data);
      }
    });  
  },
  buildOrdersSection: function(){
    var _this = this;
    var all_orders = [];
    console.log("build");
    if(_this.app_user.hasOwnProperty("user_type") && _this.app_user.user_type === "owner"){
      all_orders = _this.getOrdersFor("all", "all", "", "");                                                                
    }else{
      all_orders = [];
    }     
    $(".order-history-inner .order-row:not(.headers)").remove();
    if(all_orders.length > 0){
                 
     
      for(var o in all_orders){
        var order_html = ""; 
        var order = all_orders[o];
        var inv_date = new Date(order.created_at);      
        
        order_html += "<div class='order-row'>"+
            "<span>"+inv_date.getDate()+"."+inv_date.getMonth()+"."+inv_date.getFullYear()+"</span>"+
            "<span>"+order.id+"</span>"+
              "<span>"+pricing_formatter.formatPricing(order.total_price)+"</span>"+
            "<button class='button view-order' data-id='"+order.id+"'>View</button>"+
            //TODO: reorder "<button class='button reorder' data-id='"+invoice.id+"'>Reorder</button>"+
          "</div>";  
        
        $(".order-history-inner .orders-table").append(order_html);
      }            
    }else{
      $(".order-history-inner .orders-table").html("<span>No orders placed</span>");
    } 
    
    $(".view-order").on("click", function(){
      
      $(this).text("").addClass("button--loading");
      $(this).closest(".actions a.view-order").css("border", "unset");
      $("#cover-spin").css("display", "block");
      
      var params = {
        "order_id": $(this).attr("data-id")
      };
      
      _this.current_invoice.id = $(this).attr("data-id");
      
      params = JSON.stringify(params);
      
       $.ajax({   
          type: "POST",
          url: _this.generate_invoice,
          data: params
        }).done(function(data) {
          if(data.statusCode === 500){
            alert("There was an error generating your invoice"); 
            _this.current_invoice.id = "";
          } else {
            _this.current_invoice.encoded = data.body;   
            var frame_src= "data:application/pdf;base64,"+data.body;
            $("#invoice-window").attr("src", frame_src).attr("title","order-"+_this.current_invoice.id);
            $("#invoice-window-mobile").attr("src", frame_src).attr("title","order-"+_this.current_invoice.id);
            
            
            $(".user-section.invoice").show(0);
            $(".view-orders").hide(0);
            
            $(".invoice-header .order-no").text(_this.current_invoice.id);
            $(".invoice-download").attr("download", "order-"+_this.current_invoice.id).attr("href",frame_src);
          }
          $(".view-order").text("View").css("pointer-events", "auto");
          $(".view-order").removeClass("button--loading");
          $(".actions a").css("border", "1px solid #c1c1c1");
          $("#cover-spin").css("display", "none");
          
        });      
    }); 
    
    $(".invoice-back").on("click", function(){
      _this.changeToSection(_this.invoice_return);
    });

     $(".view-order-mobile").on("click", function(){
      
      $(this).text("").addClass("button--loading");
      $(this).closest(".actions a.view-order-mobile").css("border", "unset");
      $("#cover-spin").css("display", "block");
      
      var params = {
        "order_id": $(this).attr("data-id")
      };
      
      _this.current_invoice.id = $(this).attr("data-id");
      
      params = JSON.stringify(params);
      
      $.ajax({   
        type: "POST",
        url: _this.generate_invoice,
        data: params
      }).done(function(data) {
        if(data.statusCode === 500){
          alert("There was an error generating your invoice"); 
          _this.current_invoice.id = "";
        } else {
          _this.current_invoice.encoded = data.body;   
          var frame_src= "data:application/pdf;base64,"+data.body;
          $("#invoice-window-mobile").attr("src", frame_src).attr("title","order-"+_this.current_invoice.id);
          $(".invoice-header .order-no").text(_this.current_invoice.id);
          $(".invoice-download").attr("download", "order-"+_this.current_invoice.id).attr("href",frame_src);
          $('.invoice-actions a')[0].click();
        }
        $(".view-order-mobile").text("View").css("pointer-events", "auto");
        $(".view-order-mobile").removeClass("button--loading");
        $(".actions a").css("border", "1px solid #c1c1c1");
        $("#cover-spin").css("display", "none");
        
      });      
    }); 
    
    
  },
  updateUser: function(cb){
    var _this = this;
    
    var keys_to_delete = ["sub_users_full", "locations", "type"];
    
    _this.submitted_user_info = _this.user;
    
    var updateable = _this.user;
    
    for(var dk in keys_to_delete){
      var key = keys_to_delete[dk];
      delete updateable[key];
    }
    
    console.log(updateable);
    
    parsed_user = JSON.stringify(updateable);
    
    $.ajax({
      type: "POST",
      url: _this.update_url,
      data: parsed_user
    }).done(function(data) {
      if(data.body.error){
        showMessage(data.body.error); 
      }else{
        $(".user-update").text("Update").attr("disabled", false);
      }
      if(cb){
        cb();
      }
    });
  },
  updateSubUser: function(user_id){
    var _this = this;
    
    var sub_user = {};
    
    $(".user-update").css({"background": g_colours.greenish_grey}).text("Updating...").attr("disabled", "disabled");
    
    sub_user.user_id = user_id;
    
    var sub_user_elements = [
      {"selector":"#user-f-name", "key": "first_name"},
      {"selector":"#user-l-name", "key": "last_name"}     
    ];
    
    for(var e in sub_user_elements){
      var selector = sub_user_elements[e].selector;
      var key = sub_user_elements[e].key;
      sub_user[key] = $(selector).val();
    }    
    
    sub_user.access_authorities = ["default"];

    $(".edit-user-permissions input[type='checkbox']").each(function(){
      if($(this).prop("checked") === true){
        sub_user.access_authorities.push($(this).val());
      }
    }); 
    
    var permissions_type = $("input[name='p-types']:checked").val().replace(/\s/g,"_");

    sub_user.access_authorities.push("type_"+permissions_type);    
    
    console.log(sub_user);
    
    parsed_user = JSON.stringify(sub_user);
    
    $.ajax({
      type: "POST",
      url: _this.update_url,
      data: parsed_user
    }).done(function(data) {
      $(".user-update").css({"background": "#000"}).text("Update").attr("disabled", false);
      if(data.body.error){
        showMessage(data.body.error);         
      }else{
        $(".user-update").text("Update").attr("disabled", false);
        $(".edit-general-inner").hide();
        $(".account-general-inner").show();
        //_this.setGeneralInfo();
        _this.changeToSection("users");
      }
    });  
  },
  setListeners: function(){
    var _this = this;
    
    $(".open-edit-address").on("click", function(){
      _this.changeToSection("edit-address");
      _this.populateEditAddress($(this).attr("data-id"));
    }); 
    
    $(".user-display.primary .user-edit").on("click", function(){
      _this.openEditUser("primary");           
    });
    
    $(".user-add").on("click", function(){
      $(".user-section.users").hide();
      $(".user-section.add-user").show(); 
      $(".section-title.permissions-title, .new-user-permissions").show(); 
      $(".permission-groups .checkbox-element input:checked").change();
      
      $(".checkbox-element .custom-check-refresh input").prop("checked", false);
      $(".permissions-indv .checkbox-element").addClass("disabled");
      $(".permissions-indv .checkbox-element").removeClass("active");
      $(".permission-groups .cb-inner").removeClass("addfontfamily");
      $(".permission-groups .checkbox-element").removeClass("checkbackground");
      $(".addefaultclass").addClass("defaultcheckbackground");
      $(".permission-groups .cb-inner").css('color', '#808080');
      $(".addefaultfont").css('color', '#000');
      $(".addefaultfont").addClass("defaultfontfamily");
      $(".access-default").addClass("active");
      
     });
    
    $(".permission-groups input[type='radio']").on("change", function(){
      var permissions = $(this).attr("data-permissions-allow").split(",");
      var deny = $(this).attr("data-permissions-deny").split(",");
      
      $(".permission-groups .cb-inner").css({"color": ""});
       $(".permission-groups .cb-inner").css({"font-weight": ""});
      $(".permissions-indv .checkbox-element").removeClass("active disabled").find("input").prop("checked", false).change();
      
      for(var p in permissions){
        if(permissions[p] === "") continue;
        $("."+permissions[p]).addClass("active").find("input").prop("checked", "checked").change();
      }
      
      for(var d in deny){
        if(deny[d] === "") continue;
        $("."+deny[d]).addClass("disabled");
      }      
      
    });
    
    $(".orders-view-more").on("click", function(){
      $(".order-history-inner .order-row").css({"display": "flex"});
      $(".order-history-inner .order-row").each(function(i){
        var timeout = i * 100;
        setTimeout(function(){
          var child = i + 4;
          $(".order-history-inner .order-row:nth-child("+child+")").css({"opacity": "1"});
        }, timeout);
      });
    });
    
    $(".financials-view-more").on("click", function(){
      var parent = $(this).closest(".account-section");
      var section_class = parent.attr("data-section");
      parent.find(".orders-table .order-row").css({"display": "flex"});
      parent.find(".orders-table .order-row").each(function(i){
        var timeout = i * 100;
        setTimeout(function(){
          var child = i + 4;
          $("."+section_class).find(".order-row:nth-child("+child+")").css({"opacity": "1"});
        }, timeout);
      });
    });        
    
    $(".user-invite").on("click", function(){
      var user = {};
      user.fname = $("#f-name").val();
      user.lname = $("#l-name").val();
      user.email = $("#email").val();
      
      user.permissions_set = $("input[name='p-types']:checked").val();
      
      $(this).css({"background": g_colours.greenish_grey}).text("Loading...").attr("disabled", "disabled");
      
      user.type = g_customer.type;
      user.parent_id = g_customer.id;
      if(account.user.business_info.hasOwnProperty("business_name")){
        user.parent_name = _this.user.business_info.business_name;
      }else{
        user.parent_name = _this.user.email;
      }
      
      user.permissions = [];
      
      $(".new-user-permissions input[type='checkbox']").each(function(){
        if($(this).prop("checked") === true){
          user.permissions.push($(this).val());
        }
      });
      
      var permissions_type = $("input[name='p-types']:checked").val().replace(/\s/g,"_");
      
      user.permissions.push("type_"+permissions_type);
      
      if(user.fname === "" || user.lname === "" || user.email === ""){
        showMessage("Please fill out all fields");
        $(this).css({"background": "#000"}).text("Send Invite").attr("disabled", false);
        return false;
      }else{
        user = JSON.stringify(user);
        _this.sendUserInvite(user);
      }
    });
    
    $(".user-page-menu-item").on("click", function(){
      var page = $(this).attr("data-link");
      $(".user-page-menu-item").removeClass("active");
      $(this).addClass("active");
      _this.changeToSection(page);
    }); 
    
    $("#user-page-menu-mobile").on("change", function(){
      var page = $(this).val();
      _this.changeToSection(page);    
    });
    
    $(".track-heading").on("click", function(){
      var order_id = $("#track-id").val();
      _this.trackOrder(order_id);
    });
    
    $("#general-edit").on("click", function(){
      $(".account-general-inner").hide();      
      $(".edit-general-inner").show();
      $("#business_type").change();
    });
    
    $("#business_type").on("change", function(){
      if($(this).find("option:selected").val() === "Other"){
        $(".bt-other").show();
      }
    });
    
    $(".acc-edit-close").on("click", function(){
      $(".account-general-inner").show();
      $(".edit-general-inner").hide();
    });    
    
    $(".user-update").on("click", function(){
      $(".user-update").css({"background": g_colours.greenish_grey}).text("Updating...").attr("disabled", "disabled");
      if($(this).attr("data-sub") === "true"){
        var sub_id = $(this).attr("data-user-id");
        _this.updateSubUser(sub_id);
      }else{
        _this.buildUserFromForm();
      }      
    });
    
    $(".general-update").on("click", function(){
      $(".general-update").css({"background": g_colours.greenish_grey}).text("Updating...").attr("disabled", "disabled");
      _this.buildUserFromForm();     
    });    
    
    
    $(".new-address .add-wrapper").on("click", function(){
      _this.changeToSection("new-address");
      _this.generateNewAddress();
    });
    
    $('.reorder').on('click',function(){
      var order_id = $(this).attr('data-id');
      var items = [];
      
      $(this).addClass("loading").text("Loading").attr("disabled", "disabled");
      
      for(var m in g_account.orders){
        var month = g_account.orders[m];
        for(var o in month){
          var order = month[o];
          if(order.id === order_id){
            for(var i in order.reorder_items){
              _this.reorder_items.push(order.reorder_items[i]);
            }            
          }
        }
      } 
      if(_this.reorder_items.length > 0){
        _this.reorderAdd(_this.reorder_items);    
      }
    });  
    
    $(".address-country").on("change", function(){
      if($(this).children("option:selected").length === 0){
        return false;
      }
      var provinces = JSON.parse($(this).children("option:selected").attr("data-provinces"));    
      if(Object.keys(provinces).length > 0){
        var options = "";
        for(var p in provinces){
          var province = provinces[p][0];
          options += "<option value='"+province+"'>"+province+"</option>"
        }
        $(".address-province").html(options);
        
        if(typeof g_account !== "undefined" && g_account.hasOwnProperty("locations") && Object.keys(g_account.locations).length > 0){
          $(".address-province").val(g_account.locations[Object.keys(g_account.locations)[0]].province);
        }
        $(".address-province").show();
      }else{
        console.log("vall"+$(this).val());
        var state = $(this).val();
        if(state!='Australia')
        {
          $(".address-province").hide();
        }
        else
        {
          $(".address-province").show();
        }
      }
    });
    
    $(".address-edit-close, .address-new-close").on("click", function(){
      _this.changeToSection("locations");
    });
    
    
    $(".new-address-form button[type='submit']").on("click", function(){
      _this.addAddress();
    });
    
    $(".edit-address-form button[type='submit']").on("click", function(){
      _this.editAddress();
    }); 
    
    $(".edit-user-close").on("click", function(){
      _this.changeToSection("users");
    });

    $(".edit-location-close").on("click", function(){
      location.href = "/account/addresses?view=view";
    });
    
    $(".delete-user").on("click", function(){
      var sub_id = $(this).closest(".edit-user-inner").find(".user-update").attr("data-user-id");
      var params = {
        "subuser_id": sub_id,
        "user_id": _this.app_user.user_id,
        "email": $("#user-email").val()
      };
      
      params = JSON.stringify(params);
      
      _this.deleteUser(params, function(){
        delete _this.app_user.sub_users_full[sub_id];
        $(".user-display.sub[data-id='"+sub_id+"']").remove();
        _this.changeToSection("users");
        showMessage("user deleted");
      });
      
    });
    
    $("#history-range").on("change", function(){
      $(".history-bars").removeClass("bars-3 bars-6 bars-12").addClass("bars-"+$(this).val());
      $("#history-from").change();
    });
    
    $("#history-from, #history-from-year").on("change", function(){
      console.log("hambone");
      var from_year = $("#history-from-year").val();
      var from_month = $("#history-from").val();
      
      var range = parseInt($("#history-range").val()) - 1;
      var to_month = parseInt(from_month) + range;
      var to_year = from_year;
      
      if(to_month > 11){
        to_year = parseInt(from_year) + 1;
        to_month = to_month % 11;
      }
      
      $("#history-to-year").val(to_year); 
      $("#history-to").val(to_month);

      _this.setOverviewStats();
    });
    
    $("#history-to, #history-to-year").on("change", function(){
      var to_year = $("#history-to-year").val();
      var to_month = $("#history-to").val();
      
      var range = parseInt($("#history-range").val()) - 1;
      var from_month = parseInt(to_month) - range;
      var from_year = to_year;
      
      if(from_month < 0){
        from_year = parseInt(from_year) - 1;
        from_month = from_month + 11;
      }
      
      $("#history-from-year").val(from_year); 
      $("#history-from").val(from_month).change();
    });
    
    $(".open-price-matrix").on("click", function(){
      $(".pricing-overlay").css({"opacity": "1", "pointer-events": "all"});
    });
    
    $(".pricing-overlay .close-overlay").on("click", function(){
      $(".pricing-overlay").css({"opacity": "0", "pointer-events": "none"});
    });    
    
  },
  deleteUser: function(params, cb){
    var _this = this;
    $.ajax({   
      type: "POST",
      url: _this.delete_url,
      data: params
    }).done(function(data) {
      console.log(data);
      if(data.body.error){
        showMessage(data.body.error); 
      }
      if(cb){
        cb(data);
      }
    });
  },
  openEditUser: function(user_id){
    var _this = this;
    $(".user-section.users").hide();
    $(".user-section.edit-user").show();
    $(".user-update").attr("data-sub", "false").attr("data-user-id","");
    $(".checkbox-element .custom-check-refresh input").prop("checked", false);  
    $(".permission-groups .cb-inner").removeClass("addfontfamily");
    $(".permission-groups .checkbox-element").removeClass("checkbackground"); 
    $(".permissions-indv .checkbox-element").removeClass("disabled");
    
    if(user_id === "primary"){
      
      $(".user-update").attr("data-sub", "false").attr("data-user-id", this.app_user.user_id);
      $("#user-f-name").val(_this.app_user.first_name);
      $("#user-l-name").val(_this.app_user.last_name);
      $("#user-email").val(_this.app_user.email).attr("disabled", "disabled");
      $(".section-title.permissions-title, .edit-user-permissions").hide();
      $(".delete-user").hide();
      
    }else{
      
      var sub_user = _this.app_user.sub_users_full[user_id];
      $(".user-update").attr("data-sub", "true").attr("data-user-id", user_id);
      $("#user-f-name").val(sub_user.first_name);
      $("#user-l-name").val(sub_user.last_name);
      $("#user-email").val(sub_user.email).attr("disabled", "disabled");
      $(".section-title.permissions-title, .edit-user-permissions").show();   
      $(".delete-user").show();
      $(".permission-groups .cb-inner").css({"color": ""});
      $(".permission-groups .cb-inner").css({"font-weight": ""});
      
      if(sub_user.permissions.includes("type_Default")){
        $(".cb-inner").css("color", "#808080 ");
        $(".p-radio-default").parent().find(".cb-inner").css({"color": "black"});
        $(".p-radio-default").parent().find(".cb-inner").css({"font-weight": "700"});
        $(".p-radio-default").parent().find(".cb-inner").addClass("addfontfamily");
        $(".p-radio-default").parent().parent().addClass("checkbackground"); 
        $(".permissions-indv .checkbox-element").addClass("disabled"); 
        $(".permissions-indv .checkbox-element").removeClass("active"); 
        $(".permissions-indv .access-default").addClass("active");
      }
      
      if(sub_user.permissions.includes("type_Custom")){
        $(".cb-inner").css("color", "#808080 ");
        $(".p-radio-custom").parent().find(".cb-inner ").css({"color": "black"});
        $(".p-radio-custom").parent().find(".cb-inner").css({"font-weight": "700"});
        $(".p-radio-custom").parent().parent().addClass("checkbackground"); 
        $(".p-radio-custom").parent().find(".cb-inner").addClass("addfontfamily");
      }      
      
      if(sub_user.permissions.includes("type_Full_Access")){
        $(".cb-inner").css("color", "#808080 ");
        $(".p-radio-full").parent().find(".cb-inner").css({"color": "black"});
        $(".p-radio-full").parent().find(".cb-inner").css({"font-weight": "700"});
        $(".p-radio-full").parent().parent().addClass("checkbackground"); 
        $(".p-radio-full").parent().find(".cb-inner").addClass("addfontfamily");
      }            
      
      for(var p in sub_user.permissions){
        var per = sub_user.permissions[p];
        if(per !== "default"){
          $("#access-"+per).prop("checked", "checked");
        }
      }
      
    }
  },
  generateNewAddress: function(){
    var _this = this;
    if(_this.app_user.user_type === "sub" || Object.keys(_this.app_user.sub_users_full).length === 0){
      $("#new_address_owner").html("<option value='"+_this.app_user.user_id+"' selected></option>").closest(".form-element").addClass("visually-hidden");
    }else{
      $("#new_address_owner").html("<option value='"+_this.app_user.user_id+"' selected>Store Owner</option>").closest(".form-element").removeClass("visually-hidden");
    }
  },  
  reorderAdd: function(){
    var _this = this;
    var item = _this.reorder_items.pop();    
    $.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: item,
      success: function(data) {
        if(_this.reorder_items.length === 0){
          $("button.reorder").removeClass("loading").text("Reorder").attr("disabled", false);           
          cart.refreshCart(false, false);
        }else{
          _this.reorderAdd();
        }
      }
    });    
  },
  trackOrder: function(order_id){
    var _this = this;
    var params = {
      "ship_id": order_id
    };
    $.get(_this.rate_url, params).done(function(data){
      if(data.length === 0){
        showMessage("Shipment not found. Please check your shipment ID and try again.");
      }else{
        _this.setTracking();
      }
    });  
  },
  setTracking: function(){
  
  },
  setGeneralInfo: function(){
    var _this = this;

    $(".account-info-display .info-section.hiddennull").addClass("hidden");
    
    var required_keys = [
      { "key": "coffee_supplier", "selector": ".bd-coffee-supplier", form: "#coffee_supplier"},
      { "key": "abn", "selector": ".bd-abn", form: "#abn"},
      { "key": "ig_handle", "selector": ".bd-instagram", form: "#instagram"},
      { "key": "business_name", "selector": ".bd-business_name", form: "#business_name"},
      { "key": "email", "selector": ".bd-email", form: "#primary_email"},
      { "key": "phone_number", "selector": ".bd-phone", form: "#phone_number"},
      { "key": "business_type", "selector": ".bd-type", form: "#business_type"},
      { "key": "business_type_other", form: "#business_type_other"},
      { "key": "notes","selector": ".bd-notes", form: "#notes"},
    ];
    
    //business info
    if(_this.user.hasOwnProperty("business_info") && Object.keys(_this.user.business_info).length > 0){
      
      if(g_account.account_info.phone !== ""){
        _this.user.business_info.phone = g_account.account_info.phone;
        $(".bd-phone .info-body").text(_this.user.business_info.phone);
        $("#phone_number").val(_this.user.business_info.phone);
      }

      if(g_account.account_info.email !== ""){
        _this.user.business_info.email = g_account.account_info.email;  
        $(".bd-email .info-body").text(_this.user.business_info.email);
        $("#primary_email").val(_this.user.business_info.email).attr("disabled", "disabled");       
      }  
      
      for(var k in required_keys){
        var key = required_keys[k].key;
        if(_this.user.business_info.hasOwnProperty(key) && _this.user.business_info[key] !== ""){          
          
          if(key === "business_type_other"){
            if(_this.user.business_info.hasOwnProperty(key) && _this.user.business_info[key] !== ""){
              $(".bt-other").show();
            }
          }
          
          if(required_keys[k].hasOwnProperty("selector")){
            $(required_keys[k].selector).removeClass("hidden");
            $(required_keys[k].selector+" .info-body").text(_this.user.business_info[key]);
          }
          
          if(required_keys[k].hasOwnProperty("form")){
            $(required_keys[k].form).val(_this.user.business_info[key]);            
          }
        }     
      }
      $("#address_country").change(); 
    }else{
      _this.user.business_info = {};
      
      $(".bd-email .info-body").text(_this.user.email);
      $("#primary_email").val(_this.user.email).attr("disabled", "disabled"); 
      _this.user.business_info.email = g_account.account_info.email;      
      
      if(g_account.account_info.phone !== ""){
        _this.user.business_info.phone = g_account.account_info.phone;
        $(".bd-phone .info-body").text(_this.user.business_info.phone);
        $("#phone_number").val(_this.user.business_info.phone);       
      }else{
        $(".bd-phone").addClass("hidden");
      }
      
      $("#address_country").change();
      
    }

    
    var type = "";
    
    if(typeof g_customer.type !== "undefined"){
      if(_this.type_reference.hasOwnProperty(g_customer.type)){
        type = _this.type_reference[g_customer.type];
      }else{
        type = _this.type_reference.universal;    
      }      
    }else{
      type = _this.type_reference.universal;   
    }  
    
    $(".user-section .banner-right h4").html(type.full_name+"");
    $(".bd-type .info-body").text(type.name); 
    //$("#business_type").val(type.name);
    $(".p-lvl.lvl"+type.level).addClass("active");    
  },
  buildAddresses: function(){
    var _this = this;
    //primary location

    var default_address = "";
    var default_address_tmp = ""; 
    
    for(var add in _this.app_user.addresses){
      var address = _this.app_user.addresses[add];
      
      if(!default_address_tmp?.address1){
        default_address_tmp = address;
      }
      
      if(address.hasOwnProperty("default") && address.default === true){
        default_address = address;
      }
    }

    if(!Object.keys(default_address).length){
      default_address = default_address_tmp;
    }
    
    var address_keys = ["address1","address2","city","company","country","country_code","first_name","last_name","phone","province","province_code","street","zip", "owner"];        
    
    var address_tiles = "";

  
    for(var a in _this.app_user.addresses){
      var address = _this.app_user.addresses[a];
      var hide_address = localStorage.getItem("hide_address_"+address.id);
      
      if(hide_address === "true"){
        continue;
      }
      
      var default_state = "";
      for(var k in address_keys){
        var key = address_keys[k];
        if(!address.hasOwnProperty(key)){
          address[key] = "";
        }
        if(address[key] === "null" || address[key] === null){
          address[key] = "";
        }
      }
      if(address.id === default_address.id){
        default_state = 'checked="checked"';
      }
      address_tiles += '      <div class="address-tile" data-id="'+address.id+'" style="order:2;">'+
      '        <div class="input-wrapper input-set-as-default">'+        
      '          <span class="address-company">'+address.company+'</span>'+
      '          <label for="address_default_address_new" class="inline"></label>'+
      '          <div class="address-display">'+
      '            <span>'+address.first_name+' '+address.last_name+'</span>'+
      '            <span>'+address.address1+'</span>'+
      '            <span>'+address.city+' '+address.province_code+' '+address.zip+'</span>'+
      '            <span>'+address.country+'</span>'+
      '            <span>'+address.phone+'</span>';
      if(address.owner !== "" && 
         address.owner !== "unassigned" && 
         (_this.app_user.hasOwnProperty("sub_users_full") && _this.app_user.sub_users_full.hasOwnProperty(address.owner))){
        address_tiles += '<span>Belongs to '+_this.app_user.sub_users_full[address.owner].first_name+' '+_this.app_user.sub_users_full[address.owner].last_name+'</span>';
        
        $('.content.addresstitlerr[data-addid="'+address.id+'"]').append('<span>Belongs to '+_this.app_user.sub_users_full[address.owner].first_name+' '+_this.app_user.sub_users_full[address.owner].last_name+'</span>');
        $("#address_owner-"+address.id).val(address.owner).change();
        
      }      
      address_tiles += '          </div>'+
      '          <button class="open-edit-address" data-id="'+address.id+'">Edit</button>'+
      '          <button onClick="account.removeAddress('+address.id+')" class="address-remove">Remove</button>'+
      '        </div>'+
      '      </div>';
    }
    
    $(".addresses-list").prepend(address_tiles);   
    
    var location = _this.app_user.default_address; 

    if(!Object.keys(location).length){
      location = default_address;
    }

    var full_address = "";
    
    if(location){

      full_address += location.address1;
      if (location.address2 !== "" && location.address2 !== "undefined") full_address += " "+location.address2;
      if (location.city !== "") full_address += ", "+location.city+"</br>";
      if (location.zip !== "") full_address += location.zip;
      if (location.province !== "") full_address += ", "+location.province;
      if (location.country !== "") full_address += ", "+location.country;

      $(".bd-address .info-body").html(full_address);
      $("#address_street").val(location.address1 + " " +location.address2);
      $("#address_number").val(location.number);
      $("#address_suburb").val(location.city);
      $("#address_postcode").val(location.zip);
      $("#address_country").val(location.country).change();
      $("#address_id").val(location.id);
    }
    
    
    $(".open-edit-address").on("click", function(){
      _this.changeToSection("edit-address");
      _this.populateEditAddress($(this).attr("data-id"));
    });    
  },
  removeAddress: function(id){
    localStorage.setItem("hide_address_"+id, "true");
    Shopify.CustomerAddress.destroy(id, "Are you sure you wish to delete this address?");
  },
  populateUsersSelect: function(selector){
    var _this = this;
    var sub_users_options = "";
    user_id_rr = _this.app_user.user_id;

    
    console.log("_this.app_user.sub_users_full");
    console.log(_this.app_user.sub_users_full);
    
    sub_users_options += "<option value='unassigned'>Store Owned</option>"
    if(_this.app_user.hasOwnProperty("sub_users_full")){
      
      console.log("_this.app_user.sub_users_full 22");
    console.log(_this.app_user);
      
      for(var u in _this.app_user.sub_users_full){
        var su = _this.app_user.sub_users_full[u];
        sub_users_options += "<option value='"+su.user_id+"'>"+su.first_name+" "+su.last_name+"</option>";
      }
    }
    // $(selector).html(sub_users_options).change();
    $(selector).html(sub_users_options);
  },
  populateEditAddress: function(address_id){
    var _this = this;
    _this.populateUsersSelect("#edit_address_owner");
    
    var address_elements = [
      {"selector":"#edit_address_first_name", "key": "first_name"},
      {"selector":"#edit_address_last_name", "key": "last_name"},
      {"selector":"#edit_address_company", "key": "company"},
      {"selector":"#edit_address_address1", "key": "address1"},
      {"selector":"#edit_address_address2", "key": "address2"},
      {"selector":"#edit_address_city", "key": "city"},
      {"selector":"#edit_address_zip", "key": "zip"},
      {"selector":"#edit_address_phone", "key": "phone"}    
                  
    ];
    
    $("#edit_address_owner").closest(".form-element").removeClass("visually-hidden")
 
    $("#edit_address_id").val("");
    
    if(_this.app_user.addresses.hasOwnProperty(address_id)){
      
      $("#edit_address_id").val(address_id);
      
      var address = _this.app_user.addresses[address_id];            
      
      for(var ae in address_elements){
        var selector = address_elements[ae].selector;
        var key = address_elements[ae].key;
        if(address.hasOwnProperty(key) && address[key] !== "null"){
          $(selector).val(address[key]);
        }        
      }
      
      if(address.hasOwnProperty("country") && address["country"] !== "null" && address["country"] !== ""){
        $("#edit_address_country").val(address["country"]).change();
        if(address.hasOwnProperty("province") && address["province"] !== "null"){
          $("#edit_address_province").val(address["province"]);
        }
      }else{
        $("#edit_address_country").change();
      } 
      
      var is_owner = _this.app_user.hasOwnProperty("user_type") && _this.app_user.user_type === "owner";
      var is_sub = _this.app_user.hasOwnProperty("user_type") && _this.app_user.user_type === "sub";
      var user_has_locations_permission = _this.app_user.hasOwnProperty("access_authorities") && _this.app_user.access_authorities.includes("locations");
      
      var is_default_address = String(_this.app_user.default_address.id) === String(address.id);
      
      var address_has_owner = address.hasOwnProperty("owner") && address["owner"] !== "null" && address["owner"] !== "unassigned" || address["owner"] !== "";
      
      if(is_owner || user_has_locations_permission){
        if(address_has_owner){
          $("#edit_address_owner").val(address["owner"]).closest(".form-element").removeClass("visually-hidden");          
        }else{
          $("#edit_address_owner").val("unassigned").closest(".form-element").removeClass("visually-hidden");
        }    
      }else{
        if(address_has_owner){
          $("#edit_address_owner").html("<option value='"+address["owner"]+"' selected></option>").closest(".form-element").addClass("visually-hidden");          
        }else{
          $("#edit_address_owner").html("<option value='"+_this.app_user.user_id+"' selected></option>").closest(".form-element").addClass("visually-hidden");
        } 
      }      
      
    }
  },
  setUsersSection: function(){
    var _this = this;
    var subusers_processed = 0;
    $(".user-display.sub").remove();
    $(".users-heading:not(.subs)").show();
    $(".users-heading.subs").hide();
    if(_this.app_user.hasOwnProperty("sub_users")){
      _this.app_user.sub_users_full = {};
      for(var u in _this.app_user.sub_users){
        _this.getSubUser(_this.app_user.sub_users[u], function(user){
          if(user === false) return;
          subusers_processed++;
          _this.app_user.sub_users_full[user.user_id] = user;
          if(user.hasOwnProperty("access_authorities")){
            _this.app_user.sub_users_full[user.user_id].permissions = user.access_authorities;
            user.permissions = user.access_authorities;
          }                    
          _this.generateSubUser(user);
          if(subusers_processed > 0){
            $(".users-heading.subs").show();
          }
        });
      }     
    }
    var user_col = localStorage.getItem("color"+_this.app_user.user_id);
    if(user_col === null || user_col === ""){
      user_col = Math.floor(Math.random()*16777215).toString(16);
      localStorage.setItem("color"+_this.app_user.user_id, user_col);
    }
    $(".user-display.primary .user-portrait").css({"background": "#"+user_col});
    
  },
  getSubUser: function(user, cb){
    var _this = this;
    var params = {"user_id": user};
                  
    $.get(_this.get_url, params).done(function(data){    
      if(data.statusCode === 500){
        cb(false);
      }else{
        cb(data.body);
      }
    });
  },
  generateSubUser: function(user){
    var _this = this;
    
    var user_col = localStorage.getItem("color"+user.user_id);
    if(user_col === null || user_col === ""){
      user_col = Math.floor(Math.random()*16777215).toString(16);
      localStorage.setItem("color"+user.user_id, user_col);
    }    

    var user_html = '   <div class="user-display sub" data-id="'+user.user_id+'">'+
        '      <div class="user-portrait" style="background: #'+user_col+';">'+
    '      </div>'+
    '      <div class="user-name">'+
    user.first_name + " " + user.last_name+
    '      </div>'+
    '      <div class="user-access">';
    
    if(user.hasOwnProperty("permissions")){
      for(var p in user.permissions){
        if(user.permissions[p].indexOf("type_") > -1){
          user_html += user.permissions[p].replace("type_","").replace(/_/g," ")+" user";
        }        
      }
    }else{
      user_html += " Default user";
    }
    
    
    user_html += '      </div>  '+
    '      <button class="user-edit" data-user="'+user.user_id+'">Edit</button>'+
    '    </div>';
    
    $(".users-list").append(user_html);
    
    $(".user-display.sub .user-edit").off().on("click", function(){
      var id = $(this).attr("data-user");
      _this.openEditUser(id);           
    });  
  },
  setFinancials: function(){
    var _this = this;
    if(typeof g_account !== "undefined"){
      _this.setFinancialFilters();
      _this.setFinancialHeader();  
      _this.setFinancialsInvoices("all", "all", "", "");
      _this.setFinancialsPayments("all", "all", "", "");
      _this.setFinancialsStatements("all", "all", "", "");
    }else{
      console.log("no financials");
      //TODO: no account info
    }
  },
  setFinancialsInvoices: function(province, company, start_date, end_date){
    var _this = this;    
    var unkey_p = _this.unkey(province);
    var unkey_c = _this.unkey(company)
    var orders = _this.getOrdersFor(unkey_p, unkey_c, start_date, end_date);
    console.log(orders);
    if(orders.length > 0){    
      $(".accounts-table.orders-table .order-row:not(.headers)").remove();
      for(var o in orders){
        
        if(orders[o].tags.indexOf("payment_for") > -1){
          continue;
        }
        
        var invoice_html = "";
        var invoice = orders[o];
        var inv_date = new Date(invoice.created_at);
        var total_paid = 0;
        var pay_classes = "";
        var pay_text = "Pay";
        
        if(invoice.financial_status === "paid"){
          total_paid = invoice.total_price;
        }
        
        if(total_paid === invoice.total_price){
          pay_classes = "disabled";
          pay_text = "Paid"
        }
        
        invoice_html += "<div class='order-row'>"+
            "<span>"+inv_date.getDate()+"."+inv_date.getMonth()+"."+inv_date.getFullYear()+"</span>"+
            "<span>"+invoice.id+"</span>"+
              "<span>"+pricing_formatter.formatPricing(invoice.total_price)+"</span>"+
            "<span>"+pricing_formatter.formatPricing(total_paid)+"</span>"+
            "<button class='button view-order' data-id='"+invoice.id+"'>View</button>"+
            //TODO: Pay 
            "<button class='button pay "+pay_classes+"' data-id='"+invoice.id+"'>"+pay_text+"</button>"+
          "</div>";
        
        $(".accounts-table.orders-table").append(invoice_html);
      }
    }else{
      $(".accounts-table.orders-table").html("<span>No invoices available</span>");
    }
    
    // invoice payment feature
    $(".order .pay-btn").on("click", function(){
      // $(this).text("Processing").css("pointer-events", "none");
      $(this).text("").addClass("button--loading");
      $(this).closest(".actions a.pay-btn").css("border", "unset");
      
      var order_no = $(this).attr("data-id");
      var total = $(this).attr("data-total_price") / 100;
      
    var params = {};
    
    var payment_title = "Payment for order "+order_no;
    
    params.payment_items = [
      {
        price: total,
        title: payment_title,
        quantity: 1,
        properties: [
          {
          "name": "payment_for",
          "value": order_no
          }          
        ]
      }
    ];
    
    params.tags = "payment,payment_for_"+order_no;    
    
    if(g_customer && g_customer.hasOwnProperty("type")){      
      params.user_type = g_customer.type;    
    }else{
      params.user_type = "universal";
    }  
   
    if(g_customer && g_customer.hasOwnProperty("id")){      
      params.user_id = g_customer.id;    
    }  
    
    var su = getCookie("su");
    
    if(su !== ""){
      params.subuser_id = su;
    }
    
    params = JSON.stringify(params);

    $.ajax({
      type: "POST",
      url: _this.checkout_url,
      data: params
    }).done(function(data) {
      if(data.statusCode === 500){
        alert("There was an error processing your payment");
      }else{
        if(data?.body?.hasOwnProperty("checkout")){
          location.href = data.body.checkout;
        }else{
          alert("There was an error processing invoice payment");
        } 
      }
      $(this).text("").removeClass("button--loading");
      setTimeout(function () {
        $(".actions a").css("border", "1px solid #c1c1c1");
      }, 3000);
    });     
    });   
  },
  setFinancialsPayments: function(province, company, start_date, end_date){
    var _this = this;
    var invoice_html = "";
    var unkey_p = _this.unkey(province);
    var unkey_c = _this.unkey(company)    
    var orders = _this.getOrdersFor(unkey_p, unkey_c, start_date, end_date);
    var payments_count = 0;
    $(".payments-table.orders-table .order-row:not(.headers)").remove();
    if(orders.length > 0){    
      for(var o in orders){
        var order = orders[o];
        var invoice_html = "";
        if(order.tags.indexOf("payment_for") > -1){
          payments_count++;
          var tags = order.tags.split(",");
          var inv_date = new Date(order.created_at);
          var total_paid = order.total_price;
          var invoice_no = "";
          for(var t in tags){
            if(tags[t].indexOf("payment_for") > -1){
              invoice_no = tags[t].replace("payment_for_","").trim();
            }
          }
          
          invoice_html += "<div class='order-row'>"+
              "<span>"+inv_date.getDate()+"."+inv_date.getMonth()+"."+inv_date.getFullYear()+"</span>"+
              "<span>"+invoice_no+"</span>"+
              "<span>"+pricing_formatter.formatPricing(order.total_price)+"</span>"+
              "<span>"+pricing_formatter.formatPricing(total_paid)+"</span>"+
              "<button class='button view-order' data-id='"+invoice_no+"'>View</button>"+
              "<button class='button download-payment' data-id='"+invoice_no+"'>Download</button>"+
            "</div>";

          $(".payments-table.orders-table").append(invoice_html);          
        }
      }
      if(payments_count === 0){
        $(".payments-table.orders-table").html("<span class='np-sign'>No payments available</span>");
      }
    }else{
      $(".payments-table.orders-table").html("<span class='np-sign'>No payments available</span>");
    }
    
    $(".download-payment").on("click", function(){
      
      $(this).css({"background": g_colours.greenish_grey}).text("Generating").attr("disabled", "disabled");
      
      var params = {
        "order_id": $(this).attr("data-id")
      };
      
      _this.current_invoice.id = $(this).attr("data-id");
      
      params = JSON.stringify(params);
      
      console.log(params);
      
      $.ajax({   
        type: "POST",
        url: _this.generate_invoice,
        data: params
      }).done(function(data) {
        if(data.statusCode === 500){
          showMessage("There was an error generating your invoice"); 
          _this.current_invoice.id = "";
        }else{
          _this.current_invoice.encoded = data.body;          
          var frame_src= "data:application/pdf;base64,"+data.body;
          var a = document.createElement("a");
          a.href = frame_src;
          a.download = "order-"+_this.current_invoice.id;
          a.click();  
        }
        $(".download-payment").css({"background": "#000"}).text("View").attr("disabled", false);
      });     
    });
  },
  setFinancialsStatements: function(){
    var _this = this;
    var invoice_html = "";
    if(_this.statements.length > 0){    
      $(".statements-table.orders-table").html("");
      for(var i in _this.statements){
        var invoice = _this.statements[i];
        var inv_date = i.split("-");
        inv_date = inv_date[1].substring(0,3);+" "+inv_date[0]
        invoice_html += "<div class='order-row'>"+
            "<span>"+inv_date+"</span>"+
            "<span>"+invoice.total_orders+"</span>"+
            "<span>$"+(parseFloat(invoice.total_spent) / 100)+"</span>"+
            "<span>$"+(parseFloat(invoice.closing_balance) / 100)+"</span>"+
            "<button class='button view-order' data-id='"+i+"'>View</button>"+
            "<button class='button download' data-id='"+i+"'>Download</button>"+
          "</div>";
        
        $(".statements-table.orders-table").append(invoice_html);
      }
    }else{
      $(".statements-table.orders-table").html("<span>No statements available</span>");
    }   
  },
  setFinancialHeader: function(){
    var _this = this;
    if(_this.app_user.hasOwnProperty("business_info")){
      $(".fin-owner").text(_this.app_user.business_info.business_name);
    }else{
      $(".fin-owner").text(_this.app_user.first_name +" "+_this.app_user.last_name);
    }
    
    $(".fin-filter-region").text("All Regions");
    $(".fin-filter-account-status").html("<span class='account-status-dot'></span><span>Account Active</span>");
    
    //$(".fin-filter-state.credit-balance").show();
    
    if(_this.app_user.tags.indexOf("terms") > -1){
      let terms_term = "Credit Checkout";
      if(_this.app_user.tags.indexOf("net30") > -1){
        terms_term = "30 Day Credit Terms";
      }else if(_this.app_user.tags.indexOf("net14") > -1){
        terms_term = "14 Day Credit Terms";
      }else if(_this.app_user.tags.indexOf("net21") > -1){
        terms_term = "21 Day Credit Terms";
      }else{
        terms_term = "Credit Terms";
      }
      $(".fin-filter-terms").text(terms_term);
    }else{
      $(".fin-filter-terms").hide();
    }    

    if(_this.app_user.credit_limit !== "" || _this.app_user.credit_used !== ""){
      
      var credit_limit = (parseInt(_this.app_user.credit_limit) || 0) * 100;
      
      var credit_used = (parseInt(_this.app_user.credit_used) || 0) * 100;
      
      $(".fin-status-item.current-bal").text(pricing_formatter.formatPricing(credit_limit - credit_used));
      $(".fin-status-item.overdue14-bal").text(pricing_formatter.formatPricing(_this.balances.od14));  
      $(".fin-status-item.overdue30-bal").text(pricing_formatter.formatPricing(_this.balances.od30));
      $(".fin-status-item.overdue-bal").text(pricing_formatter.formatPricing(_this.balances.odplus));
      $(".fin-status-item.outstanding-bal").text(pricing_formatter.formatPricing(_this.balances.outstanding));
      
    }else{
      $(".fin-filter-state.credit-balance").hide();
    }    
  }, 
  getOrdersFor: function(province, company, start_date, end_date){
    var _this = this;
    var all_orders = g_account.orders;
    var valid_orders = [];
    for(var o in all_orders){
      var order = all_orders[o];
      if(order.shipping_address.province === province || province === "all"){
        if(order.shipping_address.company === company || company === "all"){
          valid_orders.push(order);
        }        
      }
    }
    return valid_orders;
  },
  getPaymentsFor: function(province, company, start_date, end_date){
    var _this = this;
    var all_orders = [];
    var valid_orders = [];
    for(var o in all_orders){
      var order = all_orders[o];
      if(order.shipping_address.province === province || province === "all"){
        if(order.shipping_address.company === company || company === "all"){
          valid_orders.push(order);
        }        
      }
    }
    return valid_orders;
  },
  getStatementsFor: function(){
    var _this = this;
    var all_orders = [];
    var valid_orders = [];
    for(var o in all_orders){
      var order = all_orders[o];
      if(order.shipping_address.province === province || province === "all"){
        if(order.shipping_address.company === company || company === "all"){
          valid_orders.push(order);
        }        
      }
    }
    return valid_orders;  
  },
  getMonthlyTotalsForRange: function(province, company, start_date, end_date){
    var _this = this;
    var all_orders = g_account.orders;
    var valid_orders = [];
    var valid_dates = _this.getYearMonthsBetween(start_date, end_date);
    var monthly_totals = {};
    
    for(var o in all_orders){
      var order = all_orders[o];
      if(valid_dates.includes(order.year_month)){
        if(monthly_totals.hasOwnProperty(order.year_month)){
          monthly_totals[order.year_month].total += order.total_price;
        }else{
          monthly_totals[order.year_month] = {};
          monthly_totals[order.year_month].total = order.total_price;
        }
      }
    }
            
    return monthly_totals;  
  },
  getMonthlyTotalsFrom: function(province, company, start_date, range){
    var _this = this;
    var all_orders = g_account.orders;
    var valid_orders = [];
    var valid_dates = _this.getYearMonthsFrom(start_date, range);
    var monthly_totals = {};
    
    for(var o in all_orders){
      var order = all_orders[o];
      if(valid_dates.includes(order.year_month)){
        if(monthly_totals.hasOwnProperty(order.year_month)){
          monthly_totals[order.year_month].total += parseInt(order.total_price);
        }else{
          monthly_totals[order.year_month] = {};
          monthly_totals[order.year_month].total = parseInt(order.total_price);
        }
      }
    }
            
    return monthly_totals;  
  },    
  getAverageMonthlySpend: function(province, company, start_date, end_date){
    var _this = this;
    var all_orders = g_account.orders;
    var valid_orders = [];
    var valid_dates = _this.getYearMonthsBetween(start_date, end_date);
    var total_spend = 0;
    var total_orders = 0;
    var average_spend = 0;
    
    for(var o in all_orders){
      var order = all_orders[o];
      if(valid_dates.includes(order.year_month)){
        total_spend += parseInt(order.total_price);
        total_orders ++;
      }
    }
    
    if(total_orders !== 0){
      average_spend = total_spend / total_orders;
    }
    
    return average_spend;
  },
  getPopularProducts: function(province, company, start_date, range){
    var _this = this;
    var all_orders = g_account.orders;
    var valid_orders = [];
    var valid_dates = _this.getYearMonthsFrom(start_date, range);
    var all_products = {};
    var top_products = [];
    var max_qty = 0;
    var min_qty = 0;
    
    for(var o in all_orders){
      var order = all_orders[o];
      if(valid_dates.includes(order.year_month)){
        for(var p in order.reorder_items){
          var product = order.reorder_items[p];
          if(product === null){continue;}
          if(product.title.indexOf("Payment for order") > -1){continue;}
          if(all_products.hasOwnProperty(product.id)){
            all_products[product.title].count += product.quantity;
          }else{
            all_products[product.title] = {};
            all_products[product.title].count = product.quantity;
            all_products[product.title].title = product.title;
          }   
        }
      }
    }    
    
    for(var ap in all_products){
      var product = all_products[ap];
      if(product.count > max_qty){
        max_qty = product.count;
        top_products.push(product);
      }else if(product.count > min_qty){
        min_qty = product.count;
        top_products.push(product);
      }
      
      if(top_products.length > 5){
        top_products.shift();
      }
    }
    
    return top_products;
  },
  getYearMonthsBetween: function(start_date, end_date){
    var split = start_date.split("-");
    var start_year = split[0];
    var start_month = split[1];
    
    split = end_date.split("-");
    var end_year = split[0];
    var end_month = split[1];
    
    var year_dif = end_year - start_year;
    var active_year = start_year;
    
    var valid_dates = [start_date, end_date];
    
    var start_i = months.indexOf(start_month);
    
    for(var y = 0; y < year_dif+1; y++){    
      for(var m = start_i; m < months.length; m++){
        var new_date = active_year + "-" + months[m];
        valid_dates.push(new_date);
      }
      active_year++;
      start_i = 0;
    }
    
    return valid_dates;
  },
  getYearMonthsFrom: function(start_date, months_to_get){
    var split = start_date.split("-");
    var start_year = split[0];
    var start_month = split[1];

    var active_year = start_year;
    
    var valid_dates = [];
    
    var start_i = months.indexOf(start_month);
    var end_i = start_i + months_to_get;
    var i = start_i;
      
    for(var m = start_i; m < end_i; m++){
      if(i > months.length-1){
        i = 0;
        active_year++;
      }
      var new_date = active_year + "-" + months[i];
      valid_dates.push(new_date);
      i++;
    }
    
    return valid_dates;
  },    
  unkey: function(string){
    return string.replace(/_/g, " ");
  },
  setFinancialFilters: function(){
    var _this = this;
    
    if(!_this.app_user.hasOwnProperty("orders")){
      $(".fin-filter-regions, .fin-filter-venues").hide();
      return;
    }
    
    $(".fin-filter-regions").html('<div class="fin-filter-wrapper"><div class="fin-filter fin-province-filter active" data-province="all">All Regions</div></div>');
    $(".fin-filter-venues").html('<div class="fin-filter-wrapper"><div class="fin-filter fin-company-filter active default" data-company="all">All Venues</div></div>');
    
    
    if(Object.keys(_this.app_user.orders).length > 1){
      for(var r in _this.app_user.orders){
        if(r !== "noprovince"){
          var reg_html = '<div class="fin-filter-wrapper"><div class="fin-filter fin-province-filter" data-province="'+r+'">'+_this.unkey(r)+'</div></div>';

          $(".fin-filter-regions").append(reg_html);
          for(var c in _this.app_user.orders[r]){
            if(c !== "nocompany"){
              var com_html = '<div class="fin-filter-wrapper"><div class="fin-filter fin-company-filter '+r+'" data-company="'+c+'">'+_this.unkey(c)+'</div></div>';
              $(".fin-filter-venues").append(com_html);  
            }                  
          }
        }
      }
    }else{
      $(".fin-filter-regions, .fin-filter-venues").hide();    
    }
    
    $(".fin-province-filter").on("click", function(){
      if(!$(this).hasClass("active")){
        $(".fin-province-filter").removeClass("active");
        $(this).addClass("active");
        
        var province = $(this).attr("data-province");
        
        if(province === "all"){
          $(".fin-company-filter").removeClass("hidden");
        }else{
          $(".fin-company-filter:not(.default)").addClass("hidden");
          $(".fin-company-filter."+province).removeClass("hidden");
        }
        
        if($(".fin-company-filter.active").hasClass("hidden")){
          $(".fin-company-filter").removeClass("active");
          $(".fin-company-filter.default").addClass("active");
        }
        
        var company = $(".fin-company-filter.active").attr("data-company");
        
        _this.setFinancialsInvoices(province, company, "", "");
        _this.setFinancialsPayments(province, company, "", "");
        _this.setFinancialsStatements(province, company, "", "");        
      }
    });
    
    $(".fin-company-filter").on("click", function(){
      if(!$(this).hasClass("active")){  
        $(".fin-company-filter").removeClass("active");
        $(this).addClass("active");
        
        var province = $(".fin-province-filter.active").attr("data-province");
        var company = $(".fin-company-filter.active").attr("data-company");
        
        _this.setFinancialsInvoices(province, company, "", "");
        _this.setFinancialsPayments(province, company, "", "");
        _this.setFinancialsStatements(province, company, "", "");        
      }
    });        
    
  },
  setOverviewStats: function(){
    var _this = this;
    
    var stats = {};
    
    var d = new Date();
    
    var this_year = d.getFullYear();
    var last_year = d.getFullYear() - 1;
    
    var start_yearmonth = "";
    var end_yearmonth = "";
    
    var start_month = parseInt($("#history-from").val());
    var range = parseInt($("#history-range").val());
    var end_month = parseInt($("#history-to").val()); 
    
    var type = "";
    
    if(typeof _this.app_user.type !== "undefined"){
      if(_this.type_reference.hasOwnProperty(_this.app_user.type)){
        type = _this.type_reference[_this.app_user.type];
      }else{
        type = _this.type_reference.universal;    
      }      
    }else{
      type = _this.type_reference.universal;   
    }  
    
    var levels = parseInt(type.level);
    
    for(var l=0; l< levels; l++){
      $(".pricing-level .p-lvl.lvl-"+(l+1)).addClass("active");        
    }
    
    $(".p-table .head-prefix").remove();
    
    $(".p-table .p-col.lvl-"+type.level).addClass("active-ws").find(".p-title").prepend('<span class="head-prefix">You are<br></span>');    

    start_yearmonth = $("#history-from-year").val() + "-" + months[start_month];
    end_yearmonth = $("#history-to-year").val() + "-" + months[end_month];
    
    var average_spend = _this.getAverageMonthlySpend("all", "all", start_yearmonth, end_yearmonth);
    
    if(average_spend !== 0){
      $(".standard-box.month-spend").show().find("h2").text(pricing_formatter.formatPricing(average_spend));
    }
    
    if(_this.app_user.hasOwnProperty("credit_used") && _this.app_user.credit_used > 0){
      var credit_used_cents = _this.app_user.credit_used * 100;
      $(".standard-box.invoices").show().find("h2").text(pricing_formatter.formatPricing(credit_used_cents));
    }
    
    $(".standard-box.top-products .pc-container").html("");
    $(".standard-box.top-products .legend").html("");    
    
    $(".pricing-overlay .wholesale-open").on("click", function(){
      $(".pricing-overlay").css({"opacity": "0", "pointer-events": "none"});
    });
    
    var popular_products = _this.getPopularProducts("all", "all", start_yearmonth, range);
    
    if(popular_products.length === 0){
      $(".standard-box.top-products").hide();
    }
    
    if(popular_products.length > 2){
      var total_products = 0;
      var offset = 0
      
      var pc_html = '<div class="pc-container">';
      var pc_legend = '';
      var pc_styles = '';
      
      for(var p in popular_products){
        var product = popular_products[p];
        total_products += product.count;
      }
      
      for(var p in popular_products){
        var product = popular_products[p];
        var over_50 = product.count - (total_products / 2);
        var opacity = over_50 > 0 ? 1 : 0;
        var value = product.count / total_products * 100;        
        var pie_deg = product.count / total_products * 360;
        var title = product.title.split(" - ");
        var units = product.count > 1 ? "units" : "unit";
        title = title[0];
        pc_html += '<div class="pc-opt opt-'+p+'" data-50="'+(over_50>0)+'" data-opt="'+p+'"></div>';
        pc_legend += '<div class="pc-leg p'+p+'"><div class="dp dp-'+p+'"></div><span>'+title+'</span><span class="units"> - '+product.count+' '+units+'</span></div>';
        var a = (over_50 * -100) + "%";
        var b = ((1 + over_50) * 100) + "%";
        var degrees = offset / 100 * 360;
        var degrees_before = value / 100 * 360;
        pc_styles += ".opt-"+p+"{"+
                    "  -webkit-clip-path: polygon("+a+" "+a+", "+b+" "+a+", "+b+" "+b+", "+a+" "+b+");"+
                    "  clip-path: polygon("+a+" "+a+", "+b+" "+a+", "+b+" "+b+", "+a+" "+b+");"+
                    "  height: 100%;"+
                    "  position: absolute;"+
                    "  -webkit-transform: translate(0, -50%) rotate(90deg) rotate(calc("+degrees+" * 1deg));"+
                    "          transform: translate(0, -50%) rotate(90deg) rotate(calc("+degrees+" * 1deg));"+
                    "  -webkit-transform-origin: 50% 100%;"+
                    "          transform-origin: 50% 100%;"+
                    "  width: 100%;"+
                    "  z-index: "+Math.abs(parseInt(1+over_50))+";"+
                    "}";
        pc_styles += ".opt-"+p+":before {"+
                      "-webkit-transform: translate(-1px, 100%) rotate(calc("+degrees_before+" * 1deg));"+
                              "transform: translate(-1px, 100%) rotate(calc("+degrees_before+" * 1deg));"+
                      "-webkit-transform-origin: 50% 0%;"+
                              "transform-origin: 50% 0%;"+
                      "opacity: "+opacity+";"+
                    "}";
        offset += value;
      }
      
      pc_html += '</div>';
      
      $(".standard-box.top-products .pc-container").html(pc_html);
      $(".standard-box.top-products .legend").html(pc_legend);
      $(".standard-box.top-products").show();
    }
    $("<style>")
        .prop("type", "text/css")
        .html(pc_styles)
        .appendTo("head");  
    
    $(".pc-opt").hover(function(){
      var opt = $(this).attr("data-opt");
      $(".pc-leg").css({"opacity": "0.6"});
      $(".pc-leg.p"+opt).addClass("hover").css({"opacity": "1"});
      $(this).addClass("hover");
    }, function(){
      $(".pc-opt").removeClass("hover");
      $(".pc-leg").css({"opacity": "1"}).removeClass("hover");
    });
    
    var monthly_totals = _this.getMonthlyTotalsFrom("all", "all", start_yearmonth, range);   
    
    var active_months = _this.getYearMonthsFrom(start_yearmonth, range);
    
    $(".history-bars").html("");
    
    for(var am in active_months){
      var month_price = 0;
      var month_height = 0;
      var month_name = "";
      $(".standard-box.order-history-details").css({"display": "flex"});
      
      if(monthly_totals.hasOwnProperty(active_months[am])){
        month_price = pricing_formatter.formatPricing(monthly_totals[active_months[am]].total);
        month_height = Math.log(monthly_totals[active_months[am]].total) / Math.log(1.5);
        month_name = active_months[am].split("-");
        month_name = month_name[1].slice(0,3);
      }else{
        month_price = "";
        month_height = 0;
        month_name = active_months[am].split("-");
        month_name = month_name[1].slice(0,3);                  
      }
      
      var el = "<div class='month-bar mb-"+am+"'>"+          
          "<div class='bar' data-height='"+month_height+"'><div class='bar-price'><span>"+month_price+"</span></div></div>"+
          "<div class='bar-month'>"+month_name+"</div>"+
          "</div>";   

      $(".history-bars").append(el);  
      $(".mb-"+am+" .bar").animate({"height": month_height+"%"}, 200);
   
    }
    
    $(".toggle-section").css({"height": $(".ov-left").height()+"px"});
    
  },
  changeToSection: function(section){
    var _this = this;
    var urls = {
      "address": "/account/addresses"
    }
    
    if(section === "logout"){
      //cart.clearCart(function(){
        location.href = "/account/logout";
      //});      
    }else{
      $(".user-section").hide();
    }  
    
    if(section === "locations"){
      $(".address-tile:not(.new-address)").remove();
      _this.buildAddresses();
      $(".user-section.locations").show();
    }
    
    if(section === "new-address"){
      $(".user-section.new-address").show();
      $(".address-country").change();
    }
    
    if(section === "edit-address"){
      $(".user-section.edit-address").show();
    }    
    
    if(section === "order-history"){
      $(".user-section.order-history").show();
    } 
    
    if(section === "users"){
      _this.setUsersSection();
      $(".user-section.users").show();
    }   
    
    if(section === "overview"){
      $(".user-section.overview").show();      
    } 
    
    if(section === "invoice"){
      $(".user-section.invoice").show();      
    }     
    
    if(section === "faqs"){
      $(".user-section.faqs").show();
    } 
    
    if(section === "general"){
      $(".user-section.general").show();
    } 
    
    if(section === "projects"){
      location.href = "/pages/projects";
    }     
    
    if(section === "financials"){
      
      if($(".fin-filter-venues .fin-filter-wrapper").length > 3){
        $(".fin-filter-venues").css({"display": "block"});
        if(!$(".fin-filter-venues").hasClass("slick-initialized")){
          $(".fin-filter-venues").slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            variableWidth: true,
            inifinite: true
          });

          $(".fin-slide-back").on("click", function(){
            $(this).siblings(".fin-filter-venues").slick("slickPrev");
          });

          $(".fin-slide-next").on("click", function(){
            $(this).siblings(".fin-filter-venues").slick("slickNext");
          });        
        }
      }else{
        $(".fin-slide-back, .fin-slide-next").hide();
      } 
      
      $(".user-section.financials").show();
      
    }
    
  },
  sendUserInvite: function(user){
    var _this = this; 
    
    var required_keys = ["fname", "lname", "email", "type", "parent"];
    
    for(var k in user){
      if(!user.hasOwnProperty(k) || user[k] === ""){
        showMessage("Please ensure all fields are filled when making a new user.");
        return;
      }      
    }    
    
    $.post(_this.create_sub_url, user).done(function(data){    
      if(data.statusCode === 409){
        showMessage("That email is already in use.");
        $(".user-invite").css({"background": "#000"}).text("Send Invite").attr("disabled", false);
        return;
      }
      
      _this.app_user.sub_users.push(data.body);
      _this.app_user.sub_users_full[data.body] = JSON.parse(user);
      _this.app_user.sub_users_full[data.body].permissions = [];
      $(".new-user-form input[type='checkbox']").each(function(){
        if($(this).prop("checked") === true){
          _this.app_user.sub_users_full[data.body].permissions.push($(this).val());
        }
        $(this).prop("checked", false);
      });
      $(".new-user-form input[type='text']").each(function(){
        $(this).val("");
      });      
      showMessage("user created");
      $(".user-invite").css({"background": "#000"}).text("Send Invite").attr("disabled", false);
      _this.changeToSection("users");
    });    
  }
}

var project_landing = {
  init: function(){
    var _this = this;
    _this.setListeners();
  },
  setListeners: function(){
    var _this = this;
    
    $(".pla-item").each(function(){
      var margin = 1 + (Math.random() * 4) + "rem";
      var bg_cols = ["#666666", "#454545", "#626262", "#343434", "#4a4a4a"];
      var col = Math.floor(Math.random() * bg_cols.length);
      var bg_hex = bg_cols[col];
      //var col_min = parseInt("545454", 16);
      //var col_max = parseInt("0f0f0f", 16);
      //var bg_num = Math.floor(Math.random() * (col_max - col_min + 1) + col_min);
      //var bg_hex = "#" + bg_num.toString(16);
      //console.log(bg_hex);
      $(this).css({"margin-left": margin, "background": bg_hex});
    });
    
    $(".open-projects").on("click", function(){
      $(".po-registration-modal, .content-blocker").css({"opacity": "1", "pointer-events": "all"});

      $(".proj-modal-close, .prm-cancel").off().on("click", function(){
        $(".po-registration-modal, .content-blocker").css({"opacity": "0", "pointer-events": "none"});
      });
    });  
    
    $(".prm-send").off().on("click", function(){
      var params = {};
      $(".prm-modal-wrapper input:visible").each(function(){
        if($(this).val() === ""){
          showMessage("Please ensure all fields are filled");
          return false;
        }else{          
          params[$(this).attr("id").replace("prm-","")] = $(this).val();
        }
                
      });
      
      _this.sendProjectsApplication(params);
    });
  },
  sendProjectsApplication: async function(params){  
    var _this = this;
  
    var name = $("#prm-fname").val();
    var bname = $("#prm-lname").val();
    var email = $("#prm-email").val();
    var phone = $("#prm-phone").val();
    var idea = $("#prm-idea").val();

    var params = {
      name: name,
      bname: bname,
      email: email,
      phone: phone,
      idea: idea
    }

    var params = JSON.stringify(params);
    var res = {};

    try{
      res = await promiseAJAXRequest(params, "https://76k7muuc7k.execute-api.us-east-2.amazonaws.com/somage/app/projects/apply", "POST");
    }catch(e){
      console.log(e);
    }

console.log(res);
    
    $(".po-registration-modal, .content-blocker").css({"opacity": "0", "pointer-events": "none"});
    showMessage("Thanks for submitting your application, we'll get back to you as soon as we can.");
  }
}

    
    


$(document).ready(function(){
  
account.init();
  
  $(".orderhistory a.plus").on("click", function(){
    $(".orderhistory a.plus").hide();
        $(".orderhistory a.minus").show();
      $(".order-history .orders-list .order").css({"display": "block"});
      $(".order-history .orders-list .order").each(function(i){
        var timeout = i * 100;
        setTimeout(function(){
          var child = i + 4;
          $(".order-history .orders-list .order:nth-child("+child+")").css({"opacity": "1"});
        }, timeout);
      });
    });

  $(".orderhistory a.minus").on("click", function(){
     $(".orderhistory a.plus").show();
        $(".orderhistory a.minus").hide();
     // $(".order-history .orders-list .order").css({"display": "block"});
      $(".order-history .orders-list .order").each(function(i){
        var timeout = i * 100;
        setTimeout(function(){
          var child = i + 4;
                    $(".order-history .orders-list .order:nth-child("+child+")").css({"display": "none"});
          $(".order-history .orders-list .order:nth-child("+child+")").css({"opacity": "0"});
        }, timeout);
      });
    });
  
});